import { hasSupabaseConfig } from './lib/supabase.js';
import { getSettings, getBandName } from './lib/data.js';
import { renderShell, highlightNav } from './components/layout.js';
import { renderUvod } from './views/uvod.js';
import { renderAktuality, renderAktualita } from './views/aktuality.js';
import { renderONas } from './views/o-nas.js';
import { renderObsazeni } from './views/obsazeni.js';
import { renderMedia } from './views/media.js';
import { renderPoradatele } from './views/poradatele.js';
import { renderAnketa } from './views/anketa.js';

const app = document.getElementById('app');

function parseHash() {
    const raw = (location.hash || '#/').replace(/^#\/?/, '');
    const [route, id] = raw.split('/');
    return { route: route || '', id: id || null };
}

const ROUTE_TITLES = {
    '':           'Amati Band — západočeská zábavová kapela | živá hudba',
    'aktuality':  'Aktuality — Amati Band',
    'o-nas':      'O nás — Amati Band, kapela z Plzně a západních Čech',
    'obsazeni':   'Obsazení kapely — Amati Band',
    'media':      'Hudba, fotky a videa — Amati Band',
    'poradatele': 'Pro pořadatele — technické požadavky a kontakt | Amati Band',
    'anketa':     'Anketa: tipy na písničky — Amati Band'
};

function renderView() {
    const { route, id } = parseHash();
    const view = document.getElementById('view');
    if (!view) return;
    highlightNav(app, route);
    document.title = ROUTE_TITLES[route] || 'Amati Band';
    window.scrollTo(0, 0);
    view.innerHTML = '<div class="boot">Načítání…</div>';

    switch (route) {
        case '':           return renderUvod(view);
        case 'aktuality':  return id ? renderAktualita(view, id) : renderAktuality(view);
        case 'o-nas':      return renderONas(view);
        case 'obsazeni':   return renderObsazeni(view);
        case 'media':      return renderMedia(view);
        case 'poradatele': return renderPoradatele(view);
        case 'anketa':     return renderAnketa(view);
        default:
            view.innerHTML = `
                <section class="section narrow">
                    <h1 class="page-title">Stránka nenalezena</h1>
                    <p class="muted">Tato stránka neexistuje. <a href="#/">Zpět na úvod</a>.</p>
                </section>`;
    }
}

async function boot() {
    if (!hasSupabaseConfig) {
        app.innerHTML = `
            <div class="boot-error">
                <h1>Web není nastavený</h1>
                <p>Chybí Supabase credentials — doplň <code>.env.local</code>.</p>
            </div>`;
        return;
    }

    const [bandName, settings] = await Promise.all([getBandName(), getSettings()]);
    document.title = `${bandName} – kapela`;
    renderShell(app, { bandName, settings });

    window.addEventListener('hashchange', renderView);
    renderView();
}

boot();
